var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-sent-officer.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-3c4f0958!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-sent-officer.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSentOfficer.vue
// module id = 1327
// module chunks = 1